<template>
  <div style="font-size: 15px; border: 1px solid #E0E0E0;border-radius: 8px;padding:16px 24px">
    <div style="grid-template-columns: repeat(12, minmax(0, 1fr));display: grid; gap: 13px;">
      <div style="grid-column: span 4 / span 4;">
        <span class="font-weight-bold">Ngày chuyển: {{ transferFeeDetail.createAt }}</span>
      </div>
      <div class="font-weight-bold" style="grid-column: span 4 / span 4;text-align: center;">
        Loại chuyển :
        {{transferFeeDetail.typeTransfer ? checkEmptyData(transferFeeDetail.typeTransfer.name) : '' }}
        <span> - </span>
        {{transferFeeDetail.paymentMethod ? checkEmptyData(transferFeeDetail.paymentMethod.name) : '' }}
      </div>
      <div style="grid-column: span 4 / span 4; text-align: right">
        <span class="font-weight-bold">Người thực hiện: {{transferFeeDetail.createUser ? checkEmptyData(transferFeeDetail.createUser.fullName) : '' }}</span>
      </div>
    </div>

    <div style="grid-template-columns: repeat(13, minmax(0, 1fr));display: grid; gap: 13px;" class="mt-5">
      <div style="grid-column: span 6 / span 6;">
        <div class="package-section">
          <div class="font-weight-bold mb-2">GÓI CŨ</div>
          <div style="font-weight: 500" class="mb-1">Gói chuyển :</div>
          <div v-if="transferFeeDetail.oldPackageList && transferFeeDetail.oldPackageList.length > 0">
            <div v-for="(product, index) in transferFeeDetail.oldPackageList" :key="'product' + index" class="mt-3">
              <div style="font-weight: 500">
                {{index + 1}}. {{ product.productName }}
              </div>
              <div class="mt-1" v-if="product.durationToTransfer" style="font-style: italic; font-size: 14px">
                Thời hạn được chuyển : {{ product.durationToTransfer ? product.durationToTransfer : 0 }} tháng
              </div>
            </div>
          </div>
          <div class="mt-4">
            Học viên :
            <strong>
              {{transferFeeDetail.originCustomer ? checkEmptyData(transferFeeDetail.originCustomer.fullName) : ''}}
            </strong>
            <span v-if="transferFeeDetail.originCustomer.uid || transferFeeDetail.originCustomer.sid">
               (<span v-if="transferFeeDetail.originCustomer.uid"> UID: <strong>{{transferFeeDetail.originCustomer ? checkEmptyData(transferFeeDetail.originCustomer.uid ) : '' }}</strong></span>
            - SID: <span v-if="transferFeeDetail.originCustomer.sid"> <strong>{{transferFeeDetail.originCustomer ? checkEmptyData(transferFeeDetail.originCustomer.sid ) : '-' }}</strong></span> )
            </span>
          </div>
        </div>
      </div>

      <div style="grid-column: span 1 / span 1;" class="d-flex align-center justify-center position-relative">
        <div class="transfer-divider">
          <div class="circle-arrow">
            <v-icon color="white" size="22">mdi-arrow-right</v-icon>
          </div>
          <div class="dashed-line"></div>
        </div>
      </div>
      <div style="grid-column: span 6 / span 6;">
        <div class="package-section">
          <div class="font-weight-bold mb-2">GÓI MỚI</div>
          <div style="font-weight: 500" class="mb-1">SP nhận phí :   </div>
          <div v-if="transferFeeDetail.newProductList && transferFeeDetail.newProductList.length > 0" >
            <div v-for="(product, index) in transferFeeDetail.newProductList" :key="'product' + index" class="mt-3">
              <div style="font-weight: 500">
                {{index + 1}}. {{ product.productName }}
              </div>
              <div class="d-flex align-center justify-space-between mt-1" style="column-gap: 8px;font-style: italic; font-size: 14px">
                <div>
                  Con:   {{product.customerName ? checkEmptyData(product.customerName) : ''}}
                  - UID: {{product.customerName ? checkEmptyData(product.uid ) : '-' }}
                </div>
                <div v-if="product.durationToTransfer">
                  <span v-if="product.productType === 'sku_tutor'">
                    Số lượng: {{ product.durationToTransfer ? product.durationToTransfer : 0 }} buổi
                  </span>
                  <span v-else>
                    Số tháng được nhận: {{ product.durationToTransfer ? product.durationToTransfer : 0 }} tháng
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'PreviewTransferDuo',
  props: {
    urlERP: {
      type: String,
      default: process.env.VUE_APP_SORT_CLASS,
    },
    urlOMS: {
      type: String,
      default: process.env.VUE_APP_API_OMS,
    },
    urlCRM: {
      type: String,
      default: process.env.VUE_APP_API_ERP,
    },
    transferFeeDetail: {
      default: () => {},
    },
    isConfirm: {
      default: true,
    },
  },
  data() {
    return {
      moment,
      isShowDetailTransferFee: false,
    };
  },
  methods: {
    openDetailOrder(orderCode) {
      const orderId = orderCode ? orderCode.replace(/\D/g, '') : null;
      if(orderId) {
        const routeData = `${process.env.VUE_APP_URL_CRM}/order-detail/${orderId}?orderList=true`
        window.open(routeData, '_blank');
      }
    },
    handleShowDetail() {
      this.$emit('showTransferDetail', this.transferFeeDetail._id)
      this.isShowDetailTransferFee = true;
    },
    checkEmptyData(data) {
      return data != null || data !== '' ? data : '';
    },
  },
};
</script>

<style scoped>
.ticket-card {
  border-radius: 12px !important;
}

.package-section {
  height: 100%;
  position: relative;
}

.transfer-divider {
  position: relative;
  height: 100%;
}

.circle-arrow {
  width: 28px;
  height: 28px;
  background-color: #6F44FF;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.dashed-line {
  position: absolute;
  left: 46%;
  top: 31px;
  bottom: 0;
  border-left: 1px dashed #6F44FF;
  z-index: 1;
}

strong {
  font-weight: 600;
  color: #333;
}
.content-tooltip-transfer {
  box-shadow: 4px 4px 4px 0 rgba(102, 102, 102, 0.25);
  background: #fff !important;
}
</style>
